import type { ComponentPropsWithoutRef, ElementType } from "react";

import { cn } from "@/lib/utils/cn";

type WordmarkProps<As extends ElementType> = {
  as?: As;
  className?: string;
  dotClassName?: string;
} & Omit<ComponentPropsWithoutRef<As>, "className" | "children">;

export function Wordmark<As extends ElementType = "span">({
  as,
  className,
  dotClassName,
  ...rest
}: WordmarkProps<As>) {
  const Component = (as ?? "span") as ElementType;
  return (
    <Component
      className={cn("font-heading leading-none tracking-tight", className)}
      {...rest}
    >
      Märka
      <span className={cn("text-cobalt", dotClassName)}>.</span>
    </Component>
  );
}
